import { memo } from 'react';
import { createPortal } from 'react-dom';

import ModalV2 from '@layouts/modal/Modal.v2';

import { getStepKey, Step, StepItem, STEPS } from './MetaAccessTokenSteps';

interface MetaAccessTokenModalProps {
  isOpen: boolean;
  onClose: () => void;
  steps?: Step[];
}

const MetaAccessTokenModal = memo(
  ({ isOpen, onClose, steps = STEPS }: MetaAccessTokenModalProps) => {
    if (!isOpen) return null;

    return createPortal(
      <ModalV2
        title="How to generate a Meta Access Token"
        onClose={onClose}
        showCloseButton
        className="w-125 !rounded-2xl"
        headerClassName="border-b border-cofeeNeutral4"
      >
        <ol className="flex flex-col gap-3 text-sm text-grey80">
          {steps.map((step, index) => (
            <StepItem key={getStepKey(step)} step={step} index={index} />
          ))}
        </ol>
      </ModalV2>,
      document.body
    );
  }
);

export default MetaAccessTokenModal;
